import { IFiltersList } from "@/src/types/applicationOnline";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface OfficeAccountingFiltersState {
  actualOfficeTable: string;
  filterStatus: string;
  searchQuery: string;
  filterParams: IFiltersList | null;
  filterResults: Record<string, string[] | string | null>;
}

const initialState: OfficeAccountingFiltersState = {
  actualOfficeTable: "ALL",
  filterStatus: "All",
  searchQuery: "",
  filterParams: null,
  filterResults: {},
};

const officeAccountingFiltersSlice = createSlice({
  name: "officeAccountingFilters",
  initialState,
  reducers: {
    setActualOfficeTable(state, action: PayloadAction<string>) {
      state.actualOfficeTable = action.payload;
    },
    setFilterStatus(state, action: PayloadAction<string>) {
      state.filterStatus = action.payload;
      if (action.payload === "All") {
        state.filterResults = { ...state.filterResults, generalStatus: null };
      } else {
        state.filterResults = { ...state.filterResults, generalStatus: [action.payload] };
      }
    },
    setSearchQuery(state, action: PayloadAction<string>) {
      state.searchQuery = action.payload;
      state.filterResults = {
        ...state.filterResults,
        query: state.searchQuery,
      };
    },
    setFilterResults(state, action: PayloadAction<Record<string, string[] | string | null>>) {
      state.filterResults = action.payload;
    },
    updateFilterResult(state, action: PayloadAction<{ key: string; value: string[] | string | null }>) {
      state.filterResults = {
        ...state.filterResults,
        [action.payload.key]: action.payload.value,
      };
    },
    setFilterParams(state, action: PayloadAction<IFiltersList | null>) {
      state.filterParams = action.payload;
    },
  },
});

export const { setActualOfficeTable, setFilterStatus, setSearchQuery, setFilterResults, updateFilterResult, setFilterParams } =
  officeAccountingFiltersSlice.actions;

export default officeAccountingFiltersSlice.reducer;
